import { EntityDefinition } from '@/types/crud';

export const interactionEntity: EntityDefinition = {
  name: 'interactions',
  displayName: 'Interactions',
  displayNameSingular: 'Interaction',
  apiEndpoint: '/generic/crm_interactions',
  idField: 'id',
  nameField: 'subject',
  copyable: true,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'contact_id',
      label: 'Contact',
      type: 'select',
      required: true,
      placeholder: 'Select contact',
      order: 1
    },
    {
      key: 'company_id',
      label: 'Company',
      type: 'select',
      required: true,
      placeholder: 'Select company',
      order: 2
    },
    {
      key: 'interaction_type',
      label: 'Interaction Type',
      type: 'select',
      required: true,
      options: [
        { value: 'email', label: 'Email' },
        { value: 'call', label: 'Call' },
        { value: 'meeting', label: 'Meeting' },
        { value: 'demo', label: 'Demo' },
        { value: 'proposal', label: 'Proposal' },
        { value: 'other', label: 'Other' }
      ],
      order: 3
    },
    {
      key: 'subject',
      label: 'Subject',
      type: 'text',
      placeholder: 'Enter subject',
      order: 4
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      placeholder: 'Enter description',
      order: 5
    },
    {
      key: 'outcome',
      label: 'Outcome',
      type: 'select',
      options: [
        { value: 'positive', label: 'Positive' },
        { value: 'neutral', label: 'Neutral' },
        { value: 'negative', label: 'Negative' },
        { value: 'follow_up_required', label: 'Follow Up Required' },
        { value: 'no_response', label: 'No Response' }
      ],
      order: 6
    },
    {
      key: 'customer_stage',
      label: 'Customer Stage',
      type: 'select',
      required: true,
      options: [
        { value: 'Prospect', label: 'Prospect' },
        { value: 'Potential', label: 'Potential' },
        { value: 'Validated', label: 'Validated' },
        { value: 'Qualified', label: 'Qualified' },
        { value: 'Interested', label: 'Interested' },
        { value: 'Evaluating', label: 'Evaluating' },
        { value: 'Negotiating', label: 'Negotiating' },
        { value: 'Onboarded', label: 'Onboarded' },
        { value: 'Complaining', label: 'Complaining' },
        { value: 'Distressed', label: 'Distressed' },
        { value: 'Churned', label: 'Churned' }
      ],
      order: 7
    },
    {
      key: 'next_action',
      label: 'Next Action',
      type: 'text',
      placeholder: 'Enter next action',
      order: 8
    },
    {
      key: 'next_action_date',
      label: 'Next Action Date',
      type: 'date',
      order: 9
    },
    {
      key: 'interaction_date',
      label: 'Interaction Date',
      type: 'datetime',
      required: true,
      order: 10
    },
    {
      key: 'duration_minutes',
      label: 'Duration (Minutes)',
      type: 'number',
      placeholder: 'Enter duration in minutes',
      order: 11
    },
    {
      key: 'created_by',
      label: 'Created By',
      type: 'text',
      hidden: true,
      order: 12
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 13
    },
    {
      key: 'tenant_id',
      label: 'Tenant ID',
      type: 'text',
      hidden: true,
      order: 14
    }
  ],
  tableColumns: [
    {
      key: 'created_at',
      label: 'Date',
      sortable: true,
      render: (value: string) => {
        if (!value) return '';
        return new Date(value).toLocaleDateString();
      }
    },
    {
      key: 'contact_name',
      label: 'Contact',
      sortable: true
    },
    {
      key: 'company_name',
      label: 'Company',
      sortable: true
    },
    {
      key: 'interaction_type',
      label: 'Type',
      sortable: true
    },
    {
      key: 'subject',
      label: 'Subject',
      sortable: true
    },
    {
      key: 'outcome',
      label: 'Outcome',
      sortable: true,
      colorCoding: {
        'positive': 'text-green-600 font-medium'
      }
    },
    {
      key: 'customer_stage',
      label: 'Customer Stage',
      sortable: true,
      colorCoding: {
        'active': 'text-green-600 font-medium'
      }
    },
    {
      key: 'next_action_date',
      label: 'Next Action Date',
      sortable: true
    },
    {
      key: 'duration_minutes',
      label: 'Duration (min)',
      sortable: true
    }
  ],
  searchFields: ['subject', 'description', 'interaction_type', 'outcome', 'customer_stage'],
  defaultSort: { field: 'interaction_date', direction: 'desc' }
};
